import { render, staticRenderFns } from "./PhaseTitle.vue?vue&type=template&id=23b3ab1c"
import script from "./PhaseTitle.vue?vue&type=script&lang=js"
export * from "./PhaseTitle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports